import request from '@/utils/request'

// 问卷列表
export function getQuestionList(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/list',
    method: 'post',
    data
  })
}

// 添加问卷
export function addQuestion(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/add',
    method: 'post',
    data
  })
}

// 修改问卷
export function updateQuestion(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/edit',
    method: 'post',
    data
  })
}

// 删除问卷
export function removeQuestion(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/remove',
    method: 'post',
    data
  })
}

// 修改日志
export function logList(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/logList',
    method: 'post',
    data
  })
}
// 问卷下的问题列表
export function answerList(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/answerList',
    method: 'post',
    data
  })
}

// 设置问卷
export function settingQue(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/settingQue',
    method: 'post',
    data
  })
}
// 获取当前问卷
export function getSettingQue(data) {
  return request({
    url: '/admin/operate/webQuestionnaire/getSettingQue',
    method: 'post',
    data
  })
}
// 获取答题记录
export function recordList(data) {
  return request({
    url: '/admin/operate/webRecord/list',
    method: 'post',
    data
  })
}
// 获取答题记录
export function recordDetail(data) {
  return request({
    url: '/admin/operate/webRecord/detail',
    method: 'post',
    data
  })
}
